import WownowImage from '$common/utils/image/wownow-image';
import wxOpenAppLayout from '$common/components/wxOpenAppLayout/wxOpenAppLayout.vue'

import { urlQueries } from '$common/utils/url/url'

export default ({
  Vue,
  pageComponent,
  before,
  after
}) => {
  const __timeout = setTimeout(() => {
    clearTimeout(__timeout);
    try {
      //  将后端渲染的东西序列化成对象
      window.ssrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
    } catch (err) {}
  }, 10);
  window.Vue = Vue;
  // 设置为 false 以阻止 vue 在启动时生成生产提示
  Vue.config.productionTip = false;
  // 忽略自定义元素标签抛出的报错
  Vue.config.ignoredElements = [
    'wx-open-launch-app'
  ];
  Vue.component(WownowImage.name, WownowImage,);
  Vue.component(wxOpenAppLayout.name,wxOpenAppLayout)
  //  基本的默认配置
  const vueConfig = {
    render: h => h(pageComponent)
  };
  //  实例化 vue
  window.$vm = new Vue(Object.assign({}, vueConfig, typeof before === 'function' && before(vueConfig) || {})).$mount('#app');
  after?.(window.$vm)

  install(window.Vue)
}

const install = (Vue) => {
  const fns = {
    getQueries: urlQueries
  }
  if (!Vue.prototype.Util) {
    Vue.prototype.Util = {}
  } 
  Vue.prototype.Util = Object.assign(Vue.prototype.Util, fns)
}